import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function PainSection() {
  return <section className="w-full px-6 py-20 bg-white/50" data-id="element-106">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-107">
        {/* The Scene */}
        <AnimatedSection data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-109">
            La escena que casi nadie dice en voz alta
          </h2>
          <p className="text-lg text-charcoal/80 mb-6" data-id="element-110">
            Hay un tipo de llanto que no se ve en fotos. Es el llanto de:
          </p>
          <ul className="space-y-4 mb-8 pl-4 border-l border-sage/40" data-id="element-111">
            <li className="pl-4 text-lg text-charcoal/90" data-id="element-112">
              Estar cocinando y que te caiga encima el silencio.
            </li>
            <li className="pl-4 text-lg text-charcoal/90" data-id="element-113">
              Estar en el carro y recordar una frase exacta.
            </li>
            <li className="pl-4 text-lg text-charcoal/90" data-id="element-114">
              Estar "bien" 3 horas… y luego sentirte ridícula por seguir en
              esto.
            </li>
            <li className="pl-4 text-lg text-charcoal/90" data-id="element-115">
              Sentir alivio, y luego culpa por sentir alivio.
            </li>
          </ul>
          <p className="text-lg font-medium text-charcoal" data-id="element-116">
            Y lo peor no es sentirlo. Lo peor es pensar: <br data-id="element-117" />
            <span className="italic text-terracotta" data-id="element-118">
              "¿Y si esto soy yo ahora?"
            </span>
          </p>
        </AnimatedSection>

        {/* The Loop */}
        <AnimatedSection data-id="element-119">
          <div className="bg-stone/30 p-8 md:p-10 rounded-sm border border-stone" data-id="element-120">
            <h3 className="text-2xl font-serif text-charcoal mb-6" data-id="element-121">
              El problema real: no es la ruptura… es el bucle
            </h3>

            <div className="flex flex-wrap items-center gap-2 text-sm md:text-base text-charcoal/70 mb-8 font-medium" data-id="element-122">
              <span data-id="element-123">Desencadenante</span>
              <span data-id="element-124">→</span>
              <span data-id="element-125">Urgencia</span>
              <span data-id="element-126">→</span>
              <span className="text-terracotta" data-id="element-127">Pensamiento circular</span>
              <span data-id="element-128">→</span>
              <span data-id="element-129">Contacto / Stalkeo</span>
              <span data-id="element-130">→</span>
              <span data-id="element-131">Vergüenza</span>
              <span data-id="element-132">→</span>
              <span data-id="element-133">Cansancio</span>
            </div>

            <p className="text-lg text-charcoal/90 mb-6" data-id="element-134">
              La mayoría intenta arreglarlo con fuerza de voluntad, frases
              bonitas o distracciones.
            </p>
            <p className="text-lg font-medium text-charcoal" data-id="element-135">
              Y por eso se repite. Porque el duelo sin estructura se vuelve
              hábito.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}